import React from "react";
import { animateScroll as scroll } from "react-scroll";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinksItems,
  FooterLinkTitle,
  FooterLink,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
} from "./FooterElements";
import { GiDinosaurRex } from "react-icons/gi";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };
  return (
    <FooterContainer>
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinksItems>
              <FooterLinkTitle>Ja</FooterLinkTitle>
              <FooterLink to="/signin">Czytaj</FooterLink>
              {/* <FooterLink to="/signin">About us</FooterLink>
              <FooterLink to="/signin">About us</FooterLink>
              <FooterLink to="/signin">About us</FooterLink> */}
            </FooterLinksItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMediaWrap>
          <SocialLogo to="/" onClick={toggleHome}>
            <GiDinosaurRex />
          </SocialLogo>
          <WebsiteRights> 2021 - {new Date().getFullYear()}.</WebsiteRights>
        </SocialMediaWrap>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
